import React, { useState, useEffect } from "react";
import apiHelper from "../../../../util/ApiHelper";
import { useLoading } from "../../../../util/LoadingProvider";
import { Box, Grid, Typography } from "@material-ui/core";
import TagsForm from "./Components/TagsForm";
import TagsTable from "./Components/TagsTable";

function orderData(data) {
  let len = data.length;
  let swapped;
  do {
    swapped = false;
    for (var i = 0; i < len - 1; i++) {
      if (data[i].seq > data[i + 1].seq) {
        let temp = data[i];
        data[i] = data[i + 1];
        data[i + 1] = temp;
        swapped = true;
      }
    }
  } while (swapped);
  return data;
}

export function formatRowToData(data, seq, image) {
  var formattedData = {
    image: image ? image : data.image ? data.image : "",
    title: data.title,
    seq: data.seq ? data.seq : 0,
  };
  if (seq === 0 || seq) {
    formattedData.seq = seq;
  }
  return formattedData;
}

export default function MovieTagPage({disabled, ...props}) {
  const [globalFilter, setGlobalFilter] = useState("");
  const [isSearched, setIsSearched] = useState(false);
  const [orderingDisabled, setOrderingDisabled] = useState(false);
  const [rows, setRows] = useState([]);
  const [searchString, setSearchString] = useState("");
  const { setLoading } = useLoading();

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await apiHelper.cinefan.getAllTags();
      const orderedData = orderData(response.data);
      setRows(orderedData);
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  useEffect(async ()=>{
    await fetchData();
  }, [])

  const minSeq = () => {
    return rows[0] ? rows[0].seq - 1 : 0;
  };

  const handleSorting = (bool) => {
    if (!isSearched) {
      setOrderingDisabled(bool);
    }
  };

  const handleSearch = (searchString) => {
    setGlobalFilter(searchString);
    setIsSearched(true);
    setOrderingDisabled(true);
  };

  return (
    <>
      <Box width="100%">
        <Typography variant="h4" gutterBottom>
          Movies &gt; Movie Tags
        </Typography>
      </Box>
      <Grid container spacing={4}>
        <Grid item xs={4}>
          <TagsForm
            description="Add New Movie Tag"
            submitBtnTxt="Add New Remark"
            gridSize={4}
            upperBtnGroupSize="75%"
            formatRowToData={formatRowToData}
            fetchData={fetchData}
            minSeq={minSeq}
            disabled={disabled}
          />
        </Grid>
        <Grid container item xs={8}>
          <TagsTable
            data={rows}
            setData={setRows}
            globalFilter={globalFilter}
            orderingDisabled={orderingDisabled}
            handleSorting={handleSorting}
            handleSearch={handleSearch}
            fetchData={fetchData}
            formatRowToData={formatRowToData}
            searchString={searchString}
            setSearchString={setSearchString}
            disabled={disabled}
          />
        </Grid>
      </Grid>
    </>
  );
}
